import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import useAxios from "axios-hooks";
import PrimaryButton from "../../../Forms/PrimaryButton";
import SuccessComponent from "../../../Util/SuccessComponent";
import ErrorComponent from "../../../Util/ErrorComponent";
import FeatureSummary from "../../../Util/FeatureSummary";

const MemberEmailUnsubscribeLegacy = () => {
  const [, unsubscribeUser] = useAxios({}, { manual: true });
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  return (
    <Formik
      initialValues={{ memberId: "" }}
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        setShowSuccess(false);
        setShowError(false);

        try {
          await unsubscribeUser({
            url: `/emails/legacy-unsubscribe/${values.memberId}`,
            method: "post",
            params: { categoryId: null },
          });

          setShowSuccess(true);
          resetForm();
        } catch (e) {
          console.error(e);
          setShowError(true);
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {({ isSubmitting }) => (
        <Form>
          <h3>Global Unsubscribe (Legacy)</h3>

          <div style={{ marginTop: 20 }}>
            <label htmlFor="memberId">
              <div>Member Id</div>
              <Field
                id="memberId"
                name="memberId"
                type="text"
                placeholder="Enter Member Id"
                required
              />
            </label>
          </div>

          <PrimaryButton
            text="Submit"
            type="submit"
            loading={isSubmitting}
            style={{ marginTop: 16 }}
          />

          <SuccessComponent
            successMessage="Legacy global unsubscribe successful."
            showSuccess={showSuccess}
            setShowSuccess={setShowSuccess}
          />

          <ErrorComponent
            errorMessage="Failed to unsubscribe (legacy)."
            showError={showError}
            setShowError={setShowError}
          />
          <FeatureSummary
              label="About Legacy Global Unsubscribe"
              summary="Globally unsubscribe a member from all email communications using the legacy system. Enter the member's ID to unsubscribe them from all email categories."
          />
        </Form>
      )}
    </Formik>
  );
};

export default MemberEmailUnsubscribeLegacy;